import React from 'react';
import GraveManagement from '../components/GraveManagement';
import './GraveManagementPage.css';

export default function GraveManagementPage() {
  return (
    <div className="grave-management-page">
      <GraveManagement />
    </div>
  );
}








